import { computed, ref, watch } from 'vue';

import { propsFactory } from '@components/utils';

import type { Ref, ComputedRef, PropType } from 'vue';

export interface ILazyProps {
  eager: boolean;
}

export interface IUseLazy {
  isBooted: Ref<boolean>;
  hasContent: ComputedRef<boolean>;
  onAfterLeave: () => void;
}

export const makeLazyProps = propsFactory(
  {
    /**
     * Принудительно рендерит контент компонента в DOM, даже если компонент скрыт. Полезно для SEO оптимизации.
     */
    eager: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'lazy'
);

export function useLazy(props: ILazyProps, active: Ref<boolean>): IUseLazy {
  const isBooted = ref(false);
  const hasContent = computed(() => isBooted.value || props.eager || active.value);

  watch(active, () => (isBooted.value = true));

  function onAfterLeave(): void {
    if (!props.eager) {
      isBooted.value = false;
    }
  }

  return { isBooted, hasContent, onAfterLeave };
}
